import React, {Component} from 'react';
import Pageheading from '../../../widgets/PageHeading';
import {Link} from "react-router-dom";

class PrivacyPolicy extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                {/*hero section start*/}
                <section className="position-relative">
                    {/*<Pageheading foldername={"Utilities"} title={"Privacy Policy"} />*/}
                    <div className="row  text-center">
                        <div className="col">
                            <h1>Politica de Confidențialitate</h1>
                        </div>
                    </div>
                </section>
                {/*hero section end*/}
                {/*body content start*/}
                <div className="page-content">
                    {/*privacy start*/}
                    <section>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 col-md-12">
                                    <p>Bine ați venit la Central Monitoring System. În
                                        această pagină vă informăm cu privire la politica noastră de confidențialitate
                                        în ceea ce privește colectarea, utilizarea și dezvăluirea informațiilor
                                        personale pe care le primim de la utilizatorii site-ului nostru.</p>
                                    <h4 className="mt-5 text-primary">Informațiile Colectate
                                    </h4>
                                    <p>Atunci când completați formularul de contact de pe site-ul nostru, vă solicităm
                                        să furnizați informații de contact, cum ar fi numele și adresa de e-mail. Aceste
                                        informații vor fi utilizate exclusiv pentru a răspunde solicitării dvs. și
                                        pentru a vă oferi serviciile solicitate.
                                    </p>
                                    <h4 className="mt-5 text-primary">Cum Utilizăm Informațiile</h4>
                                    <p>Informațiile personale furnizate de dvs. prin intermediul formularului de contact
                                        vor fi utilizate numai în scopul de a vă oferi răspunsul la întrebările sau
                                        solicitările dvs. Nu vom partaja, vinde sau închiria informațiile dvs. personale
                                        către terți fără consimțământul dvs. explicit.</p>
                                    <h4 className="mt-5 text-primary">Securitatea Informațiilor</h4>
                                    <p>Ne angajăm să protejăm informațiile personale ale utilizatorilor noștri.
                                        Implementăm măsuri de securitate adecvate pentru a proteja împotriva accesului
                                        neautorizat, modificării, divulgării sau distrugerii informațiilor dvs.
                                        personale.</p>
                                    <h4 className="mt-5 text-primary">Link-uri către Site-uri Terte</h4>
                                    <p>Site-ul nostru poate conține link-uri către site-uri terțe. Nu suntem responsabili pentru practicile de confidențialitate ale acestor site-uri și vă recomandăm să citiți politica de confidențialitate a fiecărui site pe care îl vizitați.</p>
                                    <h4 className="mt-5 text-primary">Modificări ale Politicii de Confidențialitate</h4>
                                    <p>Ne rezervăm dreptul de a actualiza sau modifica această politică de confidențialitate în orice moment. Orice modificări vor fi publicate pe această pagină, iar data ultimei actualizări va fi revizuită.</p>
                                    <h4 className="mt-5 text-primary">Contactați-ne</h4>
                                    <p>Dacă aveți întrebări sau preocupări cu privire la politica noastră de confidențialitate, vă rugăm să ne contactați la adresa contact@premium-cms.ro sau prin intermediul formularului de contact disponibil pe site.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/*privacy end*/}
                </div>
                {/*body content end*/}
            </div>

        );
    }
}

export default PrivacyPolicy;
